export default __webpack_public_path__ + "static/media/icon-loading-2.9d1cc106.svg";